export const getTenantSlugFromURL = (): string => {
  const [tenantSlug] = window.location.pathname.split('/').filter(Boolean);
  return tenantSlug;
};
